import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import template from './credit.vue';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import GoogleMaps from '../../components/googleMaps';
import { head, forEach, join, groupBy } from 'lodash-es';
import moment from 'moment';
import PayMethod from '../../components/payMethod';

@Component({
    mixins: [template],
    components: {
        UnisProductModal,
        GoogleMaps,
        PayMethod,
    },
})
export default class Credit extends Vue {
    showErrTip: boolean = false;
    errorText: String = '';
    billToId: any = '121212';
    payMethod: any = '';

    selectPayMethod() {}

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    goBillingPage() {
        this.$router.replace({
            name: 'Billing',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/credit/index.ts